import { RECEIVE_SCRIPTS, FAILURE_SCRIPTS } from '../constants/actionTypes';

export const initialState = {
  allScripts: {},
  plantingIds: [],
  fertilityIds: [],
  applicationIds: [],
};

/**
 * Handles redux state for prescriptions
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function scriptsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case RECEIVE_SCRIPTS:
      return {
        ...state,
        allScripts: action.scripts.allScripts,
        plantingIds: action.scripts.plantingIds,
        fertilityIds: action.scripts.fertilityIds,
        applicationIds: action.scripts.applicationIds,
      };
    case FAILURE_SCRIPTS:
      return {
        ...state,
      };
    default:
      return state;
  }
}

export default scriptsReducer;
